import React, { useState } from "react";
import { Droppable } from "react-beautiful-dnd";
import GeoclientTour from "./GeoclientTour";

function GeoclientToursInQuoteCreate({
  tours,
  onRemove,
  isProgress,
  handleCreate,
  onReset,
  setQuoteTitle,
}) {
  const [isTitleInputActive, setTitleInputActive] = useState(true);

  function handleTitleEdit() {
    setTitleInputActive(!isTitleInputActive);
  }

  return (
    <>
      <h2>Новая подборка</h2>
      <div className="quote__title-container">
        <input
          className={`quote__title ${
            isTitleInputActive ? "quote__title_active" : ""
          }`}
          disabled={!isTitleInputActive}
          onChange={(e) => setQuoteTitle(e.target.value)}
          placeholder="Имя не задано"
        ></input>
        <button
          type="button"
          className={`btn quote__title-edit-btn ${
            isTitleInputActive ? "quote__title-edit-btn_active" : ""
          }`}
          onClick={handleTitleEdit}
        >
          {isTitleInputActive ? "Сохранить" : "Изменить"}
        </button>
      </div>
      <Droppable droppableId="ToursInQuoteCreate">
        {(provided) => (
          <div
            id="tour-list"
            className="geoclient__tours-list tour-item"
            ref={provided.innerRef}
            {...provided.droppableProps}
          >
            {tours.map((tour, index) => (
              <GeoclientTour
                key={tour.tour_id}
                tour={tour}
                index={index}
                onRemove={onRemove}
              />
            ))}
            {provided.placeholder}
          </div>
        )}
      </Droppable>
      <div className="tours__btn-container">
        {isProgress ? (
          <img
            src="https://www.geograftour.com/static/index/img/geoclient-loader.gif"
            style={{ margin: "0 auto" }}
            alt={'Идет загрузка'}
          />
        ) : (
          <>
            <button
              id="quote_create"
              className="btn btn-create"
              onClick={handleCreate}
            >
              Создать подборку в CRM
            </button>
            <button id="clear" className="btn btn-clear" onClick={onReset}>
              Очистить
            </button>
          </>
        )}
      </div>
    </>
  );
}

export default GeoclientToursInQuoteCreate;
